import { useState, useEffect } from 'react';
import Info from '../Info';
import Chart from "react-apexcharts";
import DropdownClassic from "../../components/DropdownClassic"

// Import utilities
import { tailwindConfig } from '../../utils/Utils';

function DashboardHeatmapCard({data, title, hint, filter, updateFilter, audiences}) {

  const days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']

  const [ options, setOptions ] = useState({})
  const [loading, setLoading] = useState(false);

  const periodOptions = [
    {
      id: 0,
      period: 'Per day'
    },
    {
      id: 1,
      period: 'Per week'
    },
    {
      id: 2,
      period: 'Per month'
    }
  ]
  const [ audienceOptions, setAudienceOptions ] =useState([])

  useEffect(() => {
    setAudienceOptions(['All Audiences'].concat(audiences).map((item, idx) => {
      return {id: idx, period: item}
    }))
  }, [audiences]);

  useEffect(() => {

    if(data!=null && data!=undefined && data!={} && 'series' in data && data.series!=null && data.series!=undefined
      && 'ranges' in data && data.ranges!=null && data.ranges!=undefined) {
      setOptions({
        chart: {
          height: 150,
          type: "heatmap",
          toolbar: {
            show: true,
            tools: {
              download: false,
              selection: false,
              zoom: false,
              zoomin: false,
              zoomout: false,
              pan: false,
              reset: false,
              customIcons: []
            }
          }
        },
        plotOptions: {
          heatmap: {
            shadeIntensity: 1,
            colorScale: {
              'ranges': data.ranges
            }
          }
        },
        dataLabels: {
          enabled: false
        },
        series: data.series,
        xaxis: {
          tickAmount: filter.period=='Per day'?24:filter.period=='Per week'?7:filter.period=='Per month'?31:0,
          min: filter.period=='Per day'?0:filter.period=='Per week'?0:filter.period=='Per month'?1:0,
          tooltip: filter.period=='Per day'?{
            formatter: function (val, opts) {
              return val - 1
            }
          }:filter.period=='Per week'?{
            formatter: function (val, opts) {
              return days[val - 1]
            }
          }:filter.period=='Per month'?{
            formatter: function (val, opts) {
              return val - 1
            }
          }:{}
        },
        tooltip: {
          custom: function ({series, seriesIndex, dataPointIndex, w}) {
            if (w.globals.seriesNames[seriesIndex] !== "") {
              if (filter.period=='Per day')
                return w.globals.seriesNames[seriesIndex] + ' between ' + w.globals.labels[dataPointIndex] + ' and ' + (w.globals.labels[dataPointIndex] + 1);
              else if( filter.period=='Per week') {
                return 'Day: ' + days[Math.floor((w.globals.labels[dataPointIndex]))]
              }
              else if( filter.period=='Per month')
                return 'Day of month: ' + Math.floor((w.globals.labels[dataPointIndex])-1)
              else
                return ''
            } else {
              return "";
            }
          }
        }
      })
    }
    setLoading(false)
  }, [data]);

  useEffect(() => {}, [filter]);

  function periodFilterUpdate(period){
    updateFilter('period', period)
    setLoading(true)
  }

  function audienceFilterUpdate(audience){
    updateFilter('audience', audience)
    setLoading(true)
  }

  return (
    <div className="flex flex-col col-span-full bg-white shadow-1 rounded-sm border border-gray-200">
      <header className="px-5 py-4 border-b border-gray-100 flex items-center">
        <h2 className="font-semibold text-slate-800 m-auto">{title}</h2>
        {loading?
          <div className="sm:flex justify-items-center w-6 mr-2">
          <div className="m-auto text-center">
            <svg className="animate-spin h-8 w-full" viewBox="0 0 100 100">
              <circle cx="50" cy="50" r="45" stroke="#F7699F" strokeWidth="10" fill="transparent" strokeLinecap="round"
                      strokeDasharray="283" strokeDashoffset="75"/>
            </svg>
          </div>
        </div>:''}
        <DropdownClassic options={periodOptions} selectedFilter={filter.period} updateFunc={periodFilterUpdate}/>
        <DropdownClassic options={audienceOptions} selectedFilter={filter.audience} updateFunc={audienceFilterUpdate}/>
        <Info className="ml-2" containerClassName="min-w-80">
          <div className="text-sm">{hint}</div>
        </Info>
      </header>
      {/* Chart built with Chart.js 3 */}
      {/* Change the height attribute to adjust the chart height */}
      {
        options != {} && data!=null && 'series' in data && data.series!=null && data.series!=undefined
          && 'ranges' in data && data.ranges!=null && data.ranges!=undefined ? <div className="m-auto w-full"><Chart
        options={options}
        type="heatmap"
        width="100%"
        height="300"
        series={data.series}
        ranges={data.ranges}/></div> :
          <div className="sm:flex justify-items-center mt-5 w-full mb-5">
            <div className="m-auto text-center">
              <svg className="animate-spin h-8 w-full mb-2" viewBox="0 0 100 100">
                <circle cx="50" cy="50" r="45" stroke="#F7699F" strokeWidth="10" fill="transparent" strokeLinecap="round"
                        strokeDasharray="283" strokeDashoffset="75"/>
              </svg>
              <p className="w-full">
                Loading Heatmap...
              </p>
            </div>
          </div>
      }
    </div>
  );
}

export default DashboardHeatmapCard;
